import { render } from "./ThreecardsSection.vue?vue&type=template&id=2a51eae2&scoped=true"
import script from "./ThreecardsSection.vue?vue&type=script&lang=js"
export * from "./ThreecardsSection.vue?vue&type=script&lang=js"

import "./ThreecardsSection.vue?vue&type=style&index=0&id=2a51eae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a51eae2"]])

export default __exports__